import { Link, useLocation } from 'react-router-dom';
import classNames from './bottomTabBarItem.module.scss';

type BottomTabBarItemProps = {
  title: string;
  icon: any;
  forward: any;
};

export default function BottomTabBarItem(props: BottomTabBarItemProps) {
  const { title, icon, forward } = props;
  const { pathname } = useLocation();
  return (
    <Link
      to={forward}
      className={`${classNames.container} ${pathname.includes(forward) ? classNames['--isactive'] : ''}`}
    >
      <div className={classNames.icon}>{icon}</div>
      <div className={classNames.text}>{title}</div>
    </Link>
  );
}
